// DO NOT EDIT -- generated from fs/services/tally/tallyadmin.proto

import { ObjectType, WindowedOrgCountsInput } from './tally.proto';
import * as protobuf from '../../../google/protobuf';

export namespace TallyAdmin {

  export const GetRowColumnsAndValuesEndpoint = "/grpc/tally.TallyAdmin/GetRowColumnsAndValues";
  /** GetRowColumnsAndValues is an admin endpoint which returns the columns and values of a specified row */
  export function GetRowColumnsAndValues(sender: (req: GetRowColumnsAndValuesRequest, endpoint: string) => Promise<GetRowColumnsAndValuesResponse>, req: GetRowColumnsAndValuesRequest): { promise: () => Promise<GetRowColumnsAndValuesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRowColumnsAndValuesEndpoint),
      endpoint: GetRowColumnsAndValuesEndpoint
    };
  }

  export const PublishEventCountsTaskEndpoint = "/grpc/tally.TallyAdmin/PublishEventCountsTask";
  export function PublishEventCountsTask(sender: (req: PublishEventCountsTaskRequest, endpoint: string) => Promise<{}>, req: PublishEventCountsTaskRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, PublishEventCountsTaskEndpoint),
      endpoint: PublishEventCountsTaskEndpoint
    };
  }
}

export interface GetRowColumnsAndValuesRequest {
  key?: string;
  rowFields?: RowFieldsAdmin | null;
}

export namespace GetRowColumnsAndValuesRequest {
  export enum key_or_fields {
    key = 1,
    rowFields = 2
  }

  export function key_or_fields_oneof(m: GetRowColumnsAndValuesRequest): { opt: key_or_fields.key, val: string } | { opt: key_or_fields.rowFields, val: RowFieldsAdmin } | null {
    if (m.key != null) { return { opt: key_or_fields.key, val: m.key } }
    if (m.rowFields != null) { return { opt: key_or_fields.rowFields, val: m.rowFields } }
    return null;
  }
}

export interface RowFieldsAdmin {
  orgId: string;
  objectType: ObjectType;
  date: protobuf.timestamp | null;
}

export interface GetRowColumnsAndValuesResponse {
  rowVersion: protobuf.int64;
  hourlyCounts: HourlyCountAdmin[];
  dailyTotals: DailyTotalAdmin[];
  intervalCounts: IntervalCountAdmin[];
}

export interface HourlyCountAdmin {
  objectId: string;
  hour: protobuf.int64;
  windowId: string;
  count: protobuf.int64;
}

export interface IntervalCountAdmin {
  objectId: string;
  segmentId: string;
  interval: string;
  windowId: string;
  count: protobuf.int64;
}

export interface DailyTotalAdmin {
  objectId: string;
  count: protobuf.int64;
}

export interface PublishEventCountsTaskRequest {
  input: WindowedOrgCountsInput | null;
}
